<div class="tableContainer" [class.regularTable]="lineHasChild === false">

    <div class="tableHead">
        <!-- Tabellenkopf mit sortierbaren Titeln -->
        <div class="entryContainer">
            <div [class.hide]="searching" class="tRow theadColumns">
                @if (lineHasChild) {
                    <div class="tCellfixed"></div>
                }

                <div class="tCellflexible">
                    @for (cell of tableMeta; track cell.fieldName) {
                        @if (cell.sortable) {
                            <button type="button"
                                    class="tCell sortable"
                                    [style.width]="cell.width"
                                    [attr.aria-sort]="ariaSort(cell.fieldName)"
                                    (click)="sort(cell.sortable, cell.fieldName, cell.sortType)">
                                {{ cell.headline }}
                                @if (cell.tooltip) {
                                    <elem-tooltip [text]="cell.tooltip" style="color: white"></elem-tooltip>
                                }
                                <span class="toggleOrder"></span>
                            </button>
                        } @else {
                            <div class="tCell" [style.width]="cell.width">
                                {{ cell.headline }}
                                @if (cell.tooltip) {
                                    <elem-tooltip [text]="cell.tooltip" style="color: white"></elem-tooltip>
                                }
                            </div>
                        }
                    }
                </div>

                <div class="tCellfixed go" [class.editTableSearch]="searchTerm.length !== 0">
                    <button type="button"
                            class="openTableSearch"
                            title="Suche öffnen"
                            aria-label="Suche öffnen"
                            (click)="showSearch()"></button>
                </div>
            </div>
        </div>

        <!-- Tabellenkopf mit Volltextsuche -->
        <div class="entryContainer">
            <div [class.hide]="!searching" class="tRow theadTableSearch hide">

                <div class="tCellflexible">
                    <div class="tCell" style="width: 100%;">
                        <input type="search"
                               placeholder="Ihr Suchbegriff ..."
                               aria-label="Tabellensuche"
                               [(ngModel)]="searchTerm"
                               (keyup)="notifySearchKeyup()">
                        @if (searchTerm) {
                            <button type="button"
                                    class="clearSearch"
                                    title="Eingabe löschen"
                                    aria-label="Eingabe löschen"
                                    (click)="clearSearch()"></button>
                        }
                    </div>
                </div>

                @if (targetPath || actionFn) {
                    <div class="tCellfixed go">
                        <button type="button"
                                class="closeTableSearch"
                                (click)="hideSearch()"
                                title="Suche schließen"
                                aria-label="Suche schließen"></button>
                    </div>
                }
            </div>
        </div>
    </div>

@if (visibleTableData && visibleTableData.length > 0) {
    @for (line of visibleTableData; track pk ? line[pk] : $index) {
        <div [class]="tableHover ? 'tableBody tableHover' : 'tableBody'">

            <!-- Zusammenfassung -->
            <div class="entryContainer">
                <div class="tRow tbodyrowAbstract">
                    @if (lineHasChild) {
                        <button type="button"
                                class="tCellfixed" (click)="toggleOpen(line)"
                                [attr.aria-expanded]="isOpen(line)"
                                [attr.aria-label]="isOpen(line) ? 'Details ausblenden' : 'Details anzeigen'">
                            <span [class.toggleRowOpen]="!isOpen(line)" [class.toggleRowClose]="isOpen(line)"></span>
                        </button>
                    }

                    <div class="tCellflexible" (click)="targetPath ? goToTarget(line) : '#'">
                        @for (cell of tableMeta; track cell.fieldName) {
                            <div class="tCell" [style.width]="cell.width">
                                @switch (cell.pipeName) {
                                    @case (null) {
                                        <div>{{ line[cell.fieldName] }}</div>
                                    }
                                    @case ('formatMoney') {
                                        <div>{{ line[cell.fieldName] | formatMoney }}</div>
                                    }
                                    @case ('pickYearOfDeDate') {
                                        <div>{{ line[cell.fieldName] | pickYearOfDeDate }}</div>
                                    }
                                    @case ('pickCustomer') {
                                        <div>{{ line[cell.fieldName] | pickCustomer }}</div>
                                    }
                                    @case ('value') {
                                        <div>{{ line[cell.fieldName].value }}</div>
                                    }
                                    @case ('hover') {
                                        <div title="{{ cell.hoverTextFn(line[cell.fieldName]) }}">{{ line[cell.fieldName] }}</div>
                                    }
                                    @case ('hover_fassungsart') {
                                        <div title="{{ cell.hoverTextFn(line[cell.fieldName]) }}">{{ line[cell.fieldName] }}
                                            @if (line['versandweg'] === 'TRUSTLOG') {
                                                <span class="digital-badge" style="margin-left: 0.5rem">DIGITAL</span>
                                            }
                                            @if (line['versandweg'] === 'PDF') {
                                                <span class="digital-badge" style="margin-left: 0.5rem">PDF</span>
                                            }
                                        </div>
                                    }
                                    @case ('posteingang-datum') {
                                        <div>
                                            @if (!line['gelesen']) {
                                                <!-- gelesen -->
                                                <span style="font-weight: bold">  {{ line[cell.fieldName] | dateInput2DateValuePipe }}</span>
                                            } @else {
                                                <!-- ungelesen -->
                                                {{ line[cell.fieldName] | dateInput2DateValuePipe }}
                                            }
                                        </div>
                                    }
                                    @case ('gelesen') {
                                        <div>
                                            @if (!line['gelesen']) {
                                                <span style="font-weight: bold"> {{ line[cell.fieldName] }}</span>
                                            } @else {
                                                {{ line[cell.fieldName] }}
                                            }
                                        </div>
                                    }
                                    @case ('gelesen-icon') {
                                        <div>
                                            @if (!line[cell.fieldName]) {
                                                <i class="vhvicon vhvicon-mail-big"></i>
                                            }
                                        </div>
                                    }
                                    <!-- noch nicht fertig implementiert, koennte somit ein Icon angezeigt werden,
                                    welches eine Funktion ausloest. Die Funktion ist noch nicht implementiert -->
                                    @case ('icon') {
                                        <div>{{ line[cell.fieldName] }}
                                            <button type="button"
                                                    class="iconBlock"
                                                    aria-label="Details anzeigen"
                                                    (click)="$event.stopPropagation(); toggleOpen(line)">
                                                <i class="iconDetails" title="Details anzeigen" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    }
                                    @case ('actions') {
                                        <div class="tableRowActions">
                                            @for (action of visibleRowActions(line); track action.label) {
                                                <button type="button"
                                                        class="tableRowActionButton {{ action.cssClass }}"
                                                        title="{{ action.tooltip }}"
                                                        (click)="executeRowAction($event, action, line)">
                                                    {{ action.label }}
                                                </button>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>

                    @if (targetPath || actionFn) {
                        <button type="button" class="tCellfixed"
                                [attr.aria-label]="detailsTitle"
                                title="{{ detailsTitle }}"
                                (click)="goToTarget(line)">
                            <span [className]="detailsClass"></span>
                        </button>
                    } @else {
                        <!-- Platzhalter, damit der Body dieselbe 50px-Breite wie das Such-Icon im Header reserviert und die Spalten buendig stehen -->
                        <div class="tCellfixed"></div>
                    }
                </div>
            </div>

            <!-- bgsch Komponenten: Abstract und Actions -->
            @if (lineHasChild) {
                <div class="entryContainer"
                     elem-bgsch-table-sub
                     [open]="isOpen(line)"
                     [buergschein]="line"></div>
            }
        </div>
    }
} @else {
    <div class="tableBody">
        <div class="entryContainer">
            <div class="tRow tbodyrowAbstract">
                <div class="tCellflexible">
                    <div class="tCell" style="width: 100%; text-align: center; font-style: italic;">
                        Keine Daten vorhanden
                    </div>
                </div>
            </div>
        </div>
    </div>
}

    @if (visibleTableData && searchTerm && visibleTableData.length == 0) {
        <div>
            <div class="tableBody">
                <!-- Zusammenfassung -->
                <div class="entryContainer">
                    <div class="tRow tbodyrowAbstract">

                        <div class="tCellflexible">
                            <div class="tCell">
                                <span class="meldung">Für Ihre Sucheingabe wurden keine Treffer gefunden.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
